<template>

  <b-row align-v="start" class="pb-3">
    <b-col :sm="3" align="center" align-v="center" class="label-col pb-3 pt-2">
      <div class="has-popup" v-if="hasPopup">
        <b-button v-b-modal="modalId"
                  variant="primary"
                  block
        >
          <!--<label :label-for="id"></label>-->
          <font-awesome-icon :icon="['far','info-circle']"/> {{titleText}}
        </b-button>
        <distress-input-modal :distress-details="distressDetails"
                              :modalId="modalId" />
      </div>
      <div class="no-popup" v-if="!hasPopup">
        <label :label-for="id">{{titleText}}</label>
      </div>
    </b-col>

    <b-col sm="3" v-if="icon !== null && icon !== undefined">
      <b-img fluid :src="'/assets/distress_img/icons/' + icon"></b-img>
      <!--<b-img fluid :src="'/assets/distress_img/icons/' + Alligator-459x200.png"></b-img>-->
    </b-col>

    <b-col :sm="icon ? 6 : ''">
      <b-row>
        <b-col :sm="parseInt(dropdownColSize)">
          <b-form-radio-group
              v-model="inputValue"
              :options="options"
              buttons
              button-variant="outline-primary"
              :id="id"
              :state="isValid"/>
        </b-col>
      </b-row>

      <b-form-invalid-feedback
          :id="id + 'Invalid'"
          v-if="!(validation===undefined)"
          align="left">
        <font-awesome-icon :icon="['far','exclamation-triangle']"/> {{ validationText }}
      </b-form-invalid-feedback>

      <b-row>
        <b-col>
          <b-form-text :label-for="id"> <span v-html="description"></span></b-form-text>
        </b-col>
      </b-row>
    </b-col>



  </b-row>
</template>

<script>

  import {getValidationMessages} from './../../../../js/validation/validationMessages.js'
  import DistressInputModal from "./DistressInputModal";
  import {mapMutations} from 'vuex';


  export default {
    name: "RxRadio",
    components: {DistressInputModal},
    props: {
      value: {
        // required: true
      },
      options:  {
        type: Array,
        required: true
      },
      titleText: {
        type: String,
        required: true
      },
      description: {
        type: String,
        required: false,
      },
      id:{
        type: String,
        required: true
      },
      popup: {
        type: Boolean,
        required: false
      },
      dropdownColSize: {
        type: Number,
        default: 12
      },
      validation: {
        type: Object,
        required: false
      },
      distressDetails: {
        type: Object,
        required: false
      },
      icon:{
        type: String,
        required: false
      }
    },
    data: function(){
      return {
        showModal: false
      }
    },
    computed: {
      inputValue: {
        // inputValue's getter and setter allow v-model to chain down to subcomponents with
        // two-way binding intact.
        get() {
          return this.value
        },
        set(v) {
          if (this.validation !== undefined && this.validation !== null){
            this.validation.$touch()
          } else {
            this.setPageDirty()
          }
          this.$emit('input',v)
        }
      },
      isValid() {
        if (this.validation !== undefined){
          if (this.validation.$dirty){
            return !this.validation.$error
          }
        }
      },
      validationText(){
        if (this.validation !== undefined) {
          return getValidationMessages(this.validation)
        }
      },
      hasPopup(){
        return typeof this.distressDetails === 'object'
        // return true
      },
      modalId(){
        if (this.hasPopup){
          return this.id + 'Modal'
        }
      },

    },
    methods: {
      ...mapMutations('rx',
        ['setPageDirty'])
    }
  }
</script>

<style scoped>
.label-col {
    font-size: 1.2rem;
  }

  label {
    text-align: center;
  }

  .has-popup {
    margin-top: -.5rem;
  }
  .has-popup > button {
    font-size: 1.2rem;
    margin-bottom: 0;
  }


  .no-popup > label {
    font-size: 1.2rem;
  }
</style>